import { Component } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { imageStyles } from '../../shared/styles';
import { Loading } from '../../components/shared/Loading';
import {
  getResultUrl,
  getResultsUrlForBib,
  getResultsUrl,
} from '../../utils/resultsHelpers';
import _ from 'lodash';
import { connect } from 'react-redux';
import { styles } from '../../components/IRP/body/styles';
import { trackGoogleEvent } from '../../utils/googleEvents';
import { IRPResult } from '../eventResults/IRPResult'
import { useExtra } from '../../hooks/useExtra';
import { useEventsMerged } from '../../hooks/useEventsMerged';

const mapStateToProps = (state) => ({
  errorMessage: state.individualResult.errorMessage,
  isLoading: state.individualResult.isLoading,
  result: state.individualResult.result,
  args: state.individualResult.args,
  irpArgs: state.individualResult.args,
  wasStopped: state.individualResult.wasStopped,
  dispatch: undefined
});

class IndividualResultComponent extends Component {
  static propTypes = {
    masterId: PropTypes.any,
    entryId: PropTypes.any, //needed by connectStream to update stream subscription when entryId changes
    event: PropTypes.object,
    race: PropTypes.array,
    result: PropTypes.object,
    isLive: PropTypes.bool,
    extra: PropTypes.object,
    image: PropTypes.object,
    source: PropTypes.string,
    t: PropTypes.func,
  };

  static defaultProps = {
    event: { isLoading: true },
    race: [{ isLoading: true }],
    isLive: false,
    extra: null,
  };

  componentDidMount() {
    const {
      masterId,
      source,
    } = this.props;

    if (masterId) {
      trackGoogleEvent('IRP', 'Visit', `${source}`)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.masterId && this.props.masterId !== nextProps.masterId) {
      //masterId will be object if there's an error...
      if (typeof nextProps.masterId !== 'object') {
        //Redirect to ELP once we know masterId...
        const {
          eventId,
          eventCourseId,
          entryId,
          masterId,
          bib,
          source
        } = nextProps;

        //If we don't have bib or entry id, but have master and eventid, redirect to results
        if (masterId && eventId && !(entryId || bib)) {
          this.props.history.replace(`/event/${masterId}/results/Event/${eventId}/Results`);
        }
        else {
          const url = new URL(window.location.href);
          const category = url.searchParams.get('category') || null;
          const term = url.searchParams.get('term') || null;
          this.props.history.replace(entryId ?
            getResultUrl(eventId, eventCourseId, entryId, { masterId }, category, term, [`source=${source}`]) :
            getResultsUrlForBib(eventId, eventCourseId, bib, masterId, null, category, term, [`source=${source}`])
          );
        }
      }
    }
  }

  /**
   * If there is not referrer path or referrer path is equal to the current
   * path then hitting "Go Back" should redirect to ERP page. Closest ERP view
   * we can get for not loaded IRP page is based on event course id. IF IRP
   * does not load then we do not have information about split and division
   */
  backToResults = () => {
    const {
      eventId,
      masterId,
      referrerPath,
      eventCourseId,
      history
    } = this.props;
    const { location: { pathname = null } = {} } = window || {};
    if (!referrerPath || referrerPath === pathname) {
      history.push(getResultsUrl(masterId, eventId, eventCourseId));
    } else {
      history.goBack();
    }
  };

  renderLoader() {
    const {
      t
    } = this.props;

    return (
      <div style={{ ...imageStyles.loadingOverlay, height: 300 }}>
        <div style={imageStyles.loadingPosition}>
          <Loading timeoutMessage={t('Still thinking...')} />
        </div>
      </div>
    );
  }

  render() {
    const {
      bib,
      entryId,
      event = {},
      extra,
      image,
      isLive,
      isLoading,
      isMobile,
      mapPreview,
      masterId,
      race,
      result,
    } = this.props;

    const eventInfo = _.get(event, 'event', event || {});
    const raceLoading = _.isEmpty(race) || race[0].isLoading;
    const eventLoading = _.isEmpty(event);
    const loading = isLoading || raceLoading || eventLoading || !masterId;
    if (loading) {
      return (
        <div className={isMobile ? 'col-12 container' : 'col-8 container'} style={styles.cardContainer}>
          {this.renderLoader()}
        </div>
      );
    }

    return (
      <IRPResult
        athleteId={result.racerId}
        bib={bib}
        entryId={entryId}
        event={eventInfo}
        image={image}
        irpResult={result}
        isLive={isLive}
        isMobile={isMobile}
        mapPreview={mapPreview}
        race={race[0]}
        sponsorLogos={extra?.sponsors}
      />
    );
  }
}

const PureIndividualResultComponent = ({ eventId, masterId, ...props }) => {
  const { t } = useTranslation()
  const history = useHistory()

  const { extra } = useExtra(masterId, eventId)

  const { eventsMerged, isEventsMergedLoading } = useEventsMerged(masterId, eventId)

  return (
    <IndividualResultComponent
      {...props}
      event={eventsMerged}
      extra={extra}
      eventId={eventId}
      history={history}
      isLoading={isEventsMergedLoading}
      masterId={masterId || eventsMerged?.event.masterId}
      t={t}
    />
  )
}

export const IndividualResult = connect(mapStateToProps)(PureIndividualResultComponent);
